import { render, staticRenderFns } from "./UserDashboardProductsListItem.vue?vue&type=template&id=497bf17c&scoped=true&"
import script from "./UserDashboardProductsListItem.vue?vue&type=script&lang=js&"
export * from "./UserDashboardProductsListItem.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboardProductsListItem.vue?vue&type=style&index=0&id=497bf17c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497bf17c",
  null
  
)

export default component.exports